import type {
	FieldSchemaModel,
	RawProductColumnModel,
} from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const fieldSchemaQueries = {
	all: () => ({ queryKey: ['field-schemas'] }),
	list: () => ({
		queryKey: ['field-schemas', 'list'],
		queryFn: () =>
			client.fieldSchema.fieldSchemaList({
				context: [],
			}),
	}),
	single: (id: string) => ({
		queryKey: ['field-schemas', 'detail', id],
		queryFn: () =>
			client.fieldSchema.fieldSchemaGet({
				fieldSchemaId: id,
			}),
	}),
	rawProductColumns: () => ({
		queryKey: ['raw-product-columns'],
		queryFn: () => client.rawProduct.getRawProductColumns(),
	}),
}

export function useFieldSchemasQuery<T = FieldSchemaModel[]>(
	options?: UseQueryOptions<FieldSchemaModel[], Error, T>
) {
	return useQuery<FieldSchemaModel[], Error, T>({
		...fieldSchemaQueries.list(),
		...(options || {}),
	})
}

export function useRawProductColumnsQuery<T = RawProductColumnModel[]>(
	options?: UseQueryOptions<RawProductColumnModel[], Error, T>
) {
	return useQuery<RawProductColumnModel[], Error, T>({
		...fieldSchemaQueries.rawProductColumns(),
		...(options || {}),
	})
}
export function useFieldSchemaQuery<T = FieldSchemaModel>(
	id: string,
	options?: UseQueryOptions<FieldSchemaModel, Error, T>
) {
	return useQuery<FieldSchemaModel, Error, T>({
		...fieldSchemaQueries.single(id),
		enabled: !!id,
		...(options || {}),
	})
}
